<template>
  <div>
    <h3 class="mb-3 hp-text-color-black-1">Статистика</h3>
    <StatsTable :is_admin="is_admin" />
  </div>
</template>

<script>
import { BRow, BCol, BCard, BButton } from "bootstrap-vue";

import StatsTable from "./StatsTable.vue";

export default {
  props: {
    is_admin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    StatsTable,
  },
};
</script>
